import { ref } from 'vue'

export const loader = ref(false)
